<template>
  <v-container>
    <h1 class="mt-10 mb-5">{{ $t('nav.contact') }}</h1>
    <v-row>
      <v-col cols="6">
        <div class="item-body" style="padding-right: 30px;">
          <h2>Office Location</h2>
          <v-icon color="yellow">mdi-map-marker</v-icon><span>{{ $t('footer.address') }}</span>
          <div style="height: 100px;" />
          <h2>Contact Information</h2>
          <p><v-icon color="blue">mdi-phone</v-icon>Tel: +86-021-50917571</p>
          <p><v-icon color="green">mdi-wechat</v-icon>Wechat: 13564896570</p>
          <p><v-icon color="orange">mdi-email</v-icon>Email: info@shundacpa.com</p>
        </div>
      </v-col>
      <v-col cols="6">
        <v-img src="/assets/img/GGI3_kigmzskigmzskigm.png" alt="Illustration" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Contact',
}
</script>

<style scoped>
.item-body {
  width: 100%;
  padding-top: 10px;
  padding-bottom: 30px;
}

.item-body h2 {
  color: #01579B;
}

.item-body p {
  line-height: 2;
}
</style>